module.exports = __webpack_public_path__ + "/images/cover-hbbm-wishlist.d8e6b4f.jpg";